<template>
    <div class="kt-portlet__head">
        <div v-if="!$root.isMobile">
            <form class="isprint-filter" autocomplete="off">
                <div class="form-group mr-2">
                    <label>Denominazione</label><br>
                    <input class="form-control form-control-sm" autocomplete="off" placeholder="Denominazione"
                        type="text" v-model="search.DENOMINAZIONE.VALUE">
                </div>
                <div class="form-group mr-2">
                    <label>Tipologia Cliente:</label><br>
                    <select class="form-control form-control-sm" v-model="search.TIPOLOGIA_CLIENTE.VALUE">
                        <option value="">Tutti</option>
                        <option value="1">Persona Fisica</option>
                        <option value="2">Condominio</option>
                        <option value="3">Società</option>
                    </select>
                </div>
                <div class="form-group mr-2">
                    <label>Agente:</label><br>
                    <input class="form-control form-control-sm" autocomplete="off" placeholder="Descrizione Agente"
                        type="text" v-model="search.DESCRIZIONE_AGENTE.VALUE">
                </div>
                <div class="form-group mr-2">
                    <label>Comune</label><br>
                    <input class="form-control form-control-sm" autocomplete="off" placeholder="Comune"
                        type="text" v-model="search.NOME_COMUNE.VALUE">
                </div>
                <div class="form-group mr-2">
                    <label>Regione</label><br>
                    <input class="form-control form-control-sm" autocomplete="off" placeholder="Regione"
                        type="text" v-model="search.NOME_REGIONE.VALUE">
                </div>
                <div class="form-group mr-2">
                    <label>Provincia</label><br>
                    <input class="form-control form-control-sm" autocomplete="off" placeholder="Provincia"
                        type="text" v-model="search.NOME_PROVINCIA.VALUE">
                </div>
                <div class="form-group">
                    <label>Liste</label><br>
                    <select class="form-control form-control-sm" v-model="search.FK_ID_LISTA_CLIENTE.VALUE">
                        <option value="">Tutte le liste</option>
                        <option v-for="tipologiaLista in arrayTipologiaListe" :value="tipologiaLista.ID_LISTA" :key="tipologiaLista.ID_LISTA">
                            {{ tipologiaLista.DESCRIZIONE }}
                        </option>
                    </select>
                </div>
                <button class="btn btn-success float-right btn-sm my-2 my-sm-3" @click="creaCliente">
                    <i class="fas fa-user-plus"></i> Crea Cliente
                </button>
                <button v-if="$root.isGod" class="btn btn-info float-right btn-sm my-2 my-sm-3" @click="openPopUpLista">
                    <i class="fas fa-link"></i> Gestione Liste
                </button>
            </form>
        </div>
        <div v-else>
            <div class="d-flex justify-content-center mt-3">
                <button class="btn btn-primary btn-sm mr-2" @click="toggleFilterSidebar">
                    <i class="fas fa-filter"></i> Filtri
                </button>
                <button class="btn btn-success btn-sm mr-2" @click="creaCliente">
                    <i class="fas fa-user-plus"></i> Crea Cliente
                </button>
                
                <button v-if="$root.isGod" class="btn btn-info btn-sm " @click="openPopUpLista">
                    <i class="fas fa-link"></i> Gestione Liste
                </button>
            </div>

            <div v-if="$root.isMobile" class="sidebar" :class="{ 'sidebar-open': isFilterSidebarOpen }">
                <div class="sidebar-header">
                    <h5>Filtri</h5>
                    <button type="button" class="close" @click="toggleFilterSidebar">&times;</button>
                </div>
                <div class="sidebar-body">
                    <form class="isprint-filter" autocomplete="off">
                        <div class="form-group">
                            <label>Denominazione</label><br>
                            <input class="form-control form-control-sm" autocomplete="off" placeholder="Denominazione"
                                type="text" v-model="search.DENOMINAZIONE.VALUE">
                        </div>
                        <div class="form-group">
                            <label>Tipologia Cliente:</label><br>
                            <select class="form-control form-control-sm" v-model="search.TIPOLOGIA_CLIENTE.VALUE">
                                <option value="">Tutti</option>
                                <option value="1">Persona Fisica</option>
                                <option value="2">Condominio</option>
                                <option value="3">Società</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Agente:</label><br>
                            <input class="form-control form-control-sm" autocomplete="off" placeholder="Descrizione Agente"
                                type="text" v-model="search.DESCRIZIONE_AGENTE.VALUE">
                        </div>
                        <div class="form-group">
                            <label>Comune</label><br>
                            <input class="form-control form-control-sm" autocomplete="off" placeholder="Comune"
                                type="text" v-model="search.NOME_COMUNE.VALUE">
                        </div>
                        <div class="form-group">
                            <label>Regione</label><br>
                            <input class="form-control form-control-sm" autocomplete="off" placeholder="Regione"
                                type="text" v-model="search.NOME_REGIONE.VALUE">
                        </div>
                        <div class="form-group">
                            <label>Provincia</label><br>
                            <input class="form-control form-control-sm" autocomplete="off" placeholder="Provincia"
                                type="text" v-model="search.NOME_PROVINCIA.VALUE">
                        </div>
                        <div class="form-group">
                            <label>Liste</label><br>
                            <select class="form-control form-control-sm" v-model="search.FK_ID_LISTA_CLIENTE.VALUE">
                                <option value="">Tutte le liste</option>
                                <option v-for="tipologiaLista in arrayTipologiaListe" :value="tipologiaLista.ID_LISTA" :key="tipologiaLista.ID_LISTA">
                                    {{ tipologiaLista.DESCRIZIONE }}
                                </option>
                            </select>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div class="isprint-grid-container">
        <table v-if="!$root.isMobile" class="isprint-grid shadow">
            <thead class="isprint-grid-thead">
                <tr style="background:#3D519C;color:#fff">
                    <th style="width:25%"><span>Denominazione</span></th>
                    <th style="width:16%"><span>Agente</span></th>
                    <th style="width:20%"><span>Contatti</span></th>
                    <th style="width:7%"><span>Consumi</span></th>
                    <th style="width:7%"><span>Tensione</span></th>
                    <th style="width:20%"><span>Comune > Provincia > Regione</span></th>
                    <th style="width:5%"><span>Azioni</span></th>
                </tr>
            </thead>
            <tbody class="isprint-grid-tbody" style="font-size:14px !important">
                <tr v-for="cliente in paginatedList.arr" :key="cliente.ID_CLIENTE" style="height:50px">
                    <td style="width:25%;font-size:16px;font-weight:bold">
                        <i class="fa fa-user" v-show="cliente.TIPOLOGIA_CLIENTE == 1"></i>
                        <i class="fa fa-building" v-show="cliente.TIPOLOGIA_CLIENTE == 2"></i>
                        <i class="fa fa-industry-alt" v-show="cliente.TIPOLOGIA_CLIENTE == 3"></i>
                        {{ cliente.DENOMINAZIONE }}
                    </td>
                    <td style="width:16%;font-size:15px;">
                        <i class="fa fa-user-secret"></i>
                        {{ cliente.DESCRIZIONE_AGENTE }}
                    </td>
                    <td style="width:20%">
                        <span><i class="fad fa-phone-alt"></i> {{ cliente.TELEFONO }}</span><br />
                        <a :href="'mailto:' + cliente.EMAIL"><span><i class="fad fa-envelope"></i> {{ cliente.EMAIL }}</span></a>
                    </td>
                    <td style="width:7%">
                        <span style="font-size:14px">
                            <i class="fa fa-lightbulb text-warning"></i> {{ cliente.CONSUMO_ANNUALE_LUCE }} Kw
                        </span><br />
                        <span style="font-size:14px">
                            <i class="fa fa-gas-pump text-danger"></i> {{ cliente.CONSUMO_ANNUALE_GAS }} Smc
                        </span>
                    </td>
                    <td style="width:7%">
                        <span style="font-size:14px">
                            <i class="fas fa-bolt text-info"></i> {{ cliente.TENSIONE }} V
                        </span>
                    </td>
                    <td style="width:20%">
                        <strong><i class="fad fa-map-marker-alt fa-fw"></i>{{ cliente.NOME_COMUNE }} > {{ cliente.NOME_PROVINCIA }} > {{ cliente.NOME_REGIONE }}</strong>
                    </td>
                    <td style="width:5%">
                        <div class="btn-group float-right" role="group">
                            <button class="btn btn-warning btn-sm float-right" @click="modificaCliente(cliente)">
                                <i class="fal fa-pencil"></i>
                            </button>
                            <button class="btn btn-danger btn-sm float-right" @click="eliminaCliente(cliente)">
                                <i class="fal fa-trash"></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-if="$root.isMobile">
            <div class="card mb-3" v-for="cliente in paginatedList.arr" :key="cliente.ID_CLIENTE">
                <div class="card-body" >
                    <h5 class="card-title" @click="modificaCliente(cliente)">
                        <i class="fa fa-user" v-show="cliente.TIPOLOGIA_CLIENTE == 1"></i>
                        <i class="fa fa-building" v-show="cliente.TIPOLOGIA_CLIENTE == 2"></i>
                        <i class="fa fa-industry-alt" v-show="cliente.TIPOLOGIA_CLIENTE == 3"></i>
                        {{ cliente.DENOMINAZIONE }}
                    </h5>
                    <p class="card-text">
                        <strong>Agente:</strong> {{ cliente.DESCRIZIONE_AGENTE }}<br />
                        <strong>Contatti:</strong> <i class="fad fa-phone-alt"></i> {{ cliente.TELEFONO }}<br />
                        <a :href="'mailto:' + cliente.EMAIL"><i class="fad fa-envelope"></i> {{ cliente.EMAIL }}</a><br />
                        <strong>Comune:</strong> {{ cliente.NOME_COMUNE }} > {{ cliente.NOME_PROVINCIA }} > {{ cliente.NOME_REGIONE }}<br />
                        <strong>Consumo Luce:</strong> {{ cliente.CONSUMO_ANNUALE_LUCE }} Kw<br />
                        <strong>Consumo Gas:</strong> {{ cliente.CONSUMO_ANNUALE_GAS }} Smc<br />
                        <strong>Tensione:</strong> {{ cliente.TENSIONE }} V
                    </p>
                    <div class="btn-group float-right" role="group">
                        <button v-show="this.$root.isGod" class="btn btn-danger btn-sm" @click="eliminaCliente(cliente)">
                            <i class="fal fa-trash"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count" :numpagine="search.PAGINATION.LENGTH"></Pagine>
    </div>
  <div>
    <div v-if="!$root.isMobile">
        <div class="modal fade" id="popUpLista" data-backdrop="true" role="dialog"  aria-modal="true" >
            <div class="modal-dialog" style="min-width:1000px;"  >
                <div class="modal-content" >
                    <div class="modal-header modal-header" style="background-color: #3D519C;">
                        <h4 style="color:#fff" class="modal-title"><i class="fal fa-link fa-fw"></i> Gestione Liste</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span>&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" style="height:500px">
                       <div class="row-12">
                            <form class="isprint-filter" autocomplete="off" style="width: 100%;">
                                <div class="form-group">
                                    <label>Lista:</label><br>
                                    <input class="form-control form-control-sm"  autocomplete="off" name="adasd" placeholder="cerca tra le liste" type="text" style="width:150px" v-model="searchGestioneListe.DESCRIZIONE.VALUE">
                                </div>
                                <button class="btn btn-success float-right btn-sm" style="margin-top: 25px;" v-on:click="creaLista()"><i class="fa fa-plus fa-fw"></i>Nuova lista</button>
                            </form>
                        </div>
                        <div class="isprint-grid-container">
                            <table class="isprint-grid shadow" style="max-height: 300px;">
                                <thead class="isprint-grid-thead" >
                                    <tr style="left: 0px;background:#559CB8;color:#fff">
                                        <th  style="width:90%"><span >Descrizione</span></th>
                                        <th  style="width:10%"><span >Azioni</span></th>
                                    </tr>
                                </thead>
                                <tbody class="isprint-grid-tbody" style="font-size:14px !important ;height: 300px; max-height: 300px;">
                                    <tr style="left: 0px;height:50px" v-bind:key="lista.ID_LISTA"  v-for="lista in paginatedListModal.arr">
                                        <td  style="width:90%">
                                            <i class="fal fa-link fa-2x"></i>
                                            <strong>{{lista.DESCRIZIONE}}</strong>
                                        </td>
                                        <td  style="width:10%">
                                            <div class="btn-group" role="group" aria-label="Basic example">
                                                <button data-toggle="tooltip" data-placement="top" title="Modifica il contratto" class="btn btn-warning btn-sm float-right" v-on:click="modificaLista(lista)"><i class="fal fa-pencil" ></i></button>
                                                <button data-toggle="tooltip" data-placement="top" title="Elimina il contratto" class="btn btn-danger btn-sm float-right" v-on:click="deleteLista(lista)"><i class="fal fa-trash-alt"></i></button>
                                            </div>
                                        </td> 
                                    </tr>
                                </tbody>
                            </table>
                            <Pagine v-model="searchGestioneListe.PAGINATION.PAGE_NUMBER"  :numrighe="paginatedListModal.count"  :numpagine="searchGestioneListe.PAGINATION.LENGTH"></Pagine>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-else>
      <!-- Versione Mobile -->
      <div class="modal fade" id="popUpLista" data-backdrop="true" role="dialog" aria-modal="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header" style="background-color: #3D519C;">
              <h4 style="color:#fff" class="modal-title"><i class="fal fa-link fa-fw"></i> Gestione Liste</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span>&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form class="isprint-filter" autocomplete="off">
                <div class="form-group">
                  <label>Lista:</label><br>
                  <input class="form-control form-control-sm" autocomplete="off" placeholder="Cerca tra le liste"
                    type="text" v-model="searchGestioneListe.DESCRIZIONE.VALUE">
                </div>
                <button class="btn btn-success btn-block btn-sm" @click="creaLista">
                  <i class="fa fa-plus"></i> Nuova lista
                </button>
              </form>

              <div class="mt-3">
                <div v-for="lista in paginatedListModal.arr" :key="lista.ID_LISTA" class="card mb-2">
                  <div class="card-body">
                    <h5 class="card-title">{{ lista.DESCRIZIONE }}</h5>
                    <div class="d-flex justify-content-end">
                      <button class="btn btn-warning btn-sm mr-2" @click="modificaLista(lista)">
                        <i class="fal fa-pencil"></i> Modifica
                      </button>
                      <button class="btn btn-danger btn-sm" @click="deleteLista(lista)">
                        <i class="fal fa-trash-alt"></i> Elimina
                      </button>
                    </div>
                  </div>
                </div>
                <Pagine v-model="searchGestioneListe.PAGINATION.PAGE_NUMBER" :numrighe="paginatedListModal.count" :numpagine="searchGestioneListe.PAGINATION.LENGTH"></Pagine>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="!$root.isMobile">
        <div class="modal fade" id="popUpModificaLista" data-backdrop="true" role="dialog" aria-modal="true">
            <div class="modal-dialog" style="min-width:1000px;">
                <div class="modal-content">
                    <div class="modal-header modal-header" style="background-color: #3D519C;">
                        <h4 style="color:#fff" class="modal-title"><i class="fal fa-link fa-fw"></i> Gestione Liste</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span>&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" style="height:100px">
                        <div class="form-group col-md-12">
                            <label>Descrizione:</label>
                            <input type="text" class="form-control form-control-sm" placeholder="Inserisci Descrizione Lista" v-model="listaSelezionata.DESCRIZIONE">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-success float-right" @click="salvaLista"><i class="fa fa-check"></i> Salva</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Mobile Version -->
    <div v-else>
        <div class="modal fade" id="popUpModificaLista" data-backdrop="true" role="dialog" aria-modal="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header modal-header" style="background-color: #3D519C;">
                        <h4 style="color:#fff" class="modal-title"><i class="fal fa-link fa-fw"></i> Gestione Liste</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span>&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Descrizione:</label>
                            <input type="text" class="form-control form-control-sm" placeholder="Inserisci Descrizione Lista" v-model="listaSelezionata.DESCRIZIONE">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-success btn-block" @click="salvaLista"><i class="fa fa-check"></i> Salva</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <PopUpCliente ref="popUpCliente" :clienteSelezionato="clienteSelezionato" :arrayTipologiaListe="arrayTipologiaListe" @salva-cliente="salvaCliente" />
</template>

<script>
import Pagine from '@/components/utils/Pagine.vue';
import PopUpCliente from '@/components/PopUpCliente.vue';

export default {
    name: "Clienti",
    components: {
        Pagine,
        PopUpCliente,
    },
    data() {
        return {
            filters: global.filters,
            search: {
                PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 50 },
                FK_ID_LISTA_CLIENTE: { TYPE: 'COMBO_IN_ARRAY', VALUE: '', ARRAY: "LISTE" },
                DENOMINAZIONE: { TYPE: 'TEXT', VALUE: '' },
                NOME_COMUNE: { TYPE: 'TEXT', VALUE: '' },
                NOME_PROVINCIA: { TYPE: 'TEXT', VALUE: '' },
                NOME_REGIONE: { TYPE: 'TEXT', VALUE: '' },
                TIPOLOGIA_CLIENTE: { TYPE: 'COMBO', VALUE:''},
                DESCRIZIONE_AGENTE: {TYPE: 'TEXT', VALUE:''}
            },
            searchGestioneListe: {
                PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 50 },
                DESCRIZIONE: { TYPE: 'TEXT', VALUE: '' }
            },
            clienteSelezionato: { personaFisica: {}, personaGiuridica: {}, scadenze: [], contratti: [] },
            arrayClienti: new Array(),
            arrayListe: [],
            arrayTipologiaListe: [],
            listaSelezionata: {},
            isFilterSidebarOpen: false,
        };
    },
    methods: {
        toggleFilterSidebar() {
            this.isFilterSidebarOpen = !this.isFilterSidebarOpen;
        },
        getClienti() {
            global.utils.get('/es/clienti', {isGod : this.$root.isGod, ID_UTENTE : this.$root.utente.ID_UTENTE }, (response) => {
                this.arrayClienti = response.data;
                this.getTipologiaListe();
                global.utils.get('/es/liste', {}, (response) => {
                    this.arrayListe = response.data;
                    this.arrayClienti.forEach(cliente => {
                        cliente.LISTE = [];
                        cliente.FK_ID_LISTA_CLIENTE = 0;
                        this.arrayListe.forEach(lista => {
                            if (cliente.ID_CLIENTE == lista.FK_ID_CLIENTE) {
                                cliente.LISTE.push({ FK_ID_LISTA_CLIENTE: lista.FK_ID_LISTA_CLIENTE });
                            }
                        });
                    });
                });
            });
        },
        creaCliente() {
            this.clienteSelezionato = { ID_CLIENTE: 0, personaFisica: {}, personaGiuridica: {DENOMINAZIONE:''}, contratti: [], scadenze: [] ,TIPOLOGIA_CLIENTE: undefined};

            this.$refs.popUpCliente.openPopUp(this.clienteSelezionato);
        },
        modificaCliente(cliente) {
            this.clienteSelezionato = utils.clone(cliente);
            this.$refs.popUpCliente.getCliente(this.clienteSelezionato.ID_CLIENTE)
            this.$refs.popUpCliente.openPopUp(this.clienteSelezionato);
        },

        eliminaCliente(cliente) {
            utils.alert.confirm("Sei sicuro di voler procedere con l'eliminazione del cliente? Questa azione cancellerà ogni collegamento con i contratti associati.", () => {
                global.utils.delete('/es/cliente', { ID_CLIENTE: cliente.ID_CLIENTE }, (response) => {
                    if (response.esito == 0) {
                        utils.alert.success(response.messaggio);
                        this.getClienti();
                    }
                });
            }, this.$root);
        },
        salvaCliente(cliente) {
            console.log(cliente.personaGiuridica.DENOMINAZIONE)
                if (cliente.ID_CLIENTE > 0){
                    global.utils.put('/es/cliente', cliente, (response) => {
                        if (response.esito == 0) {
                            utils.alert.success(response.messaggio);
                            this.$refs.popUpCliente.closePopUp();
                            this.getClienti();
                        } else {
                            console.log('Errore durante l\'aggiornamento del cliente:', response);
                        }
                    });
                } else {
                    // Creazione nuovo cliente
                    global.utils.post('/es/cliente', cliente, (response) => {
                        if (response.esito == 0) {
                            utils.alert.success(response.messaggio);
                            cliente.ID_CLIENTE = response.id_inserito;
                            this.$refs.popUpCliente.closePopUp();
                            this.getClienti()
                        } else {
                            console.log('Errore durante la creazione del cliente:', response);
                        }
                    });
                }
            
        },


        getTipologiaListe() {
            global.utils.get('/es/tipologialiste', {}, (response) => {
                this.arrayTipologiaListe = response.data;
            });
        },
        openPopUpLista() {
            utils.openModal('popUpLista');
        },
        creaLista() {
            this.listaSelezionata = { ID_LISTA: 0 };
            utils.openModal('popUpModificaLista');
        },
        modificaLista(lista) {
            this.listaSelezionata = utils.clone(lista);
            utils.openModal('popUpModificaLista');
        },
        deleteLista: function(lista){
            utils.alert.confirm("Sei sicuro di volere eliminare questa lista ?",()=>{
                global.utils.delete('es/tipologialista',{ID_LISTA: lista.ID_LISTA},(response)=>{
                        if (response.esito == 0){
                            utils.alert.success(response.messaggio);
                            this.getTipologiaListe()
                        }
                    })
                },this.$root); 
        },
        salvaLista() {
            if (this.listaSelezionata.ID_LISTA > 0) {
                global.utils.put('/es/tipologialista', this.listaSelezionata, (response) => {
                    if (response.esito == 0) {
                        this.getTipologiaListe();
                        utils.closeModal('popUpModificaLista');
                        utils.alert.success(response.messaggio);
                    }
                });
            } else {
                global.utils.post('/es/tipologialista', this.listaSelezionata, (response) => {
                    if (response.esito == 0) {
                        this.getTipologiaListe();
                        utils.closeModal('popUpModificaLista');
                        utils.alert.success(response.messaggio);
                    }
                });
            }
        },
    },
    watch: {
       
        pageSize(newSize) {
            this.search.PAGINATION.PAGE_SIZE = newSize;
        }
    },
    computed: {
        paginatedList() {
            var arr = utils.inGrid(this.arrayClienti, this.search);
            return arr;
        },
        paginatedListModal() {
            var arr = utils.inGrid(this.arrayTipologiaListe, this.searchGestioneListe);
            return arr;
        },
        pageSize() {
            
            return this.$root.isMobile ? 15 : 50;
        }

    },
    mounted() {
        
        this.search.PAGINATION.PAGE_SIZE = this.pageSize;
    },
    created() {
        this.getClienti();
     
    }
};
</script>

<style scoped>
.grow {
    transition: all .2s ease-in-out;
}

.grow:hover {
    transform: scale(1.1);
}

.bg-personalizzato-on {
    background-color: blue;
    height: 70px;
}

.bg-personalizzato-off {
    background-color: rgba(5, 5, 247, 0.486);
    height: 70px;
}

.bg-white-pers {
    background-color: whitesmoke;
    color: #4e73df;
}

.pers {
    color: whitesmoke;
}
.sidebar {
    position: fixed;
    top: 0;
    right: -300px;
    width: 220px;
    height: 100%;
    background-color: white;
    z-index: 1045;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.5);
    transition: right 0.3s ease;
}

.sidebar-open {
    right: 0;
}

.sidebar-header {
    padding: 10px;
    background-color: #3D519C;
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.sidebar-body {
    padding: 20px;
}

.close {
    font-size: 24px;
    cursor: pointer;
}
</style>
